import { Breadcrumb, ConfigProvider, Typography } from 'antd'
import useTranslation from '@/hooks/useTranslation'
import T from '@/components/common/T'

const { Title, Paragraph } = Typography;

function HowItWorksPage() {
    const { t } = useTranslation();

    return (
        <main>
            <section
                style={{
                    height: 200,
                    display: "flex",
                    alignItems: "flex-start",
                    justifyContent: "center",
                    flexDirection: "column",
                    backgroundColor: "#d5e8eb",
                    borderRadius: 8,
                    paddingBlock: 25,
                    paddingInline: 50,
                }}
            >
                <Title
                    level={2}
                    style={{
                        textTransform: "uppercase",
                        color: "#2e2525",
                        fontWeight: 600,
                        fontSize: 40,
                        marginBottom: 4,
                    }}
                >
                    <T k="how_it_works.title" />
                </Title>
                <Breadcrumb
                    separator=">"
                    style={{ fontSize: 20, fontWeight: 500 }}
                    items={[
                        { title: t("how_it_works.breadcrumb.home") },
                        { title: t("how_it_works.breadcrumb.title") },
                    ]}
                />
            </section>

            <section style={{ padding: "40px 50px" }}>
                <ConfigProvider
                    theme={{
                        token: {
                            fontSize: 16,
                            lineHeight: "1.2"
                        }
                    }}
                >
                    <Paragraph><T k="how_it_works.p1" /></Paragraph>
                    <Paragraph><T k="how_it_works.p2" /></Paragraph>
                    <Paragraph>
                        <T k="how_it_works.p3_intro" />
                        <ul style={{ listStyleType: "disc", marginLeft: 15, marginBlock: "revert" }}>
                            <li style={{ marginBottom: 10 }}><T k="how_it_works.li1" /></li>
                            <li><T k="how_it_works.li2" /></li>
                        </ul>
                    </Paragraph>
                    <Paragraph><T k="how_it_works.p4" /></Paragraph>
                    <Paragraph><T k="how_it_works.p5" /></Paragraph>
                    <Paragraph><T k="how_it_works.p6" /></Paragraph>
                    <Paragraph><T k="how_it_works.p7" /></Paragraph>
                    <Paragraph><T k="how_it_works.p8" /></Paragraph>
                </ConfigProvider>
            </section>
        </main>
    )
}

export default HowItWorksPage
